import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import UserProfileLogo from "./UserProfileLogo.jsx";
import FormContainer from "../../components/form/FormContainer.jsx";
import LoadingComponent from "../../components/LoadingComponent.jsx";
import FormControl from "../../components/form/FormControl.jsx";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import {UserApi} from "../../api/authority/generated/index";
import toast from "react-hot-toast";
import Button from "../../components/Button.jsx";
import FormError from "../../components/form/FormError.jsx";

export default function UserProfile() {

    let {t} = useTranslation();

    let {context, getAuthorityConfiguration, updateIdentityUser} = useContext(GlobalContext);

    /** @var {UserProfileInput} updateProfileInput */
    let [userProfileInput, setUserProfileInput] = useState({
        firstName: context.currentIdentity?.user.firstName,
        lastName: context.currentIdentity?.user.lastName,
    });

    let [buttonPressed, setButtonPressed] = useState(false);
    let [state, setDownloading, setResult, setError] = useDownloadState();

    useEffect(() => {
        if (!buttonPressed) {
            return;
        }

        setButtonPressed(false);

        setDownloading(true);
        new UserApi(getAuthorityConfiguration())
            .updateProfile({
                userId: context.currentIdentity?.user.id,
                userProfileInput: userProfileInput,
            })
            .then(r => {
                updateIdentityUser(r);
                toast.success(t('user.profile-updated'));
            })
            .catch(e => setError(e))
            .finally(() => setDownloading(false));

    }, [buttonPressed]);

    return (
        <div>
            <UserProfileLogo/>
            <FormContainer>
                <LoadingComponent loading={state.downloading}>

                    {/* Business Profile */}
                    <section className={'mt-4'}>
                        <h2 className="text-xl leading-snug text-slate-800 dark:text-slate-100 font-bold mb-1">
                            {t('user.personal-data')}
                        </h2>

                        {state.error && <FormError error={state.error}/>}

                        <div className="grid gap-4 sm:grid-cols-2">

                            <FormControl
                                className="w-full"
                                type="text"
                                variant="modern"
                                label={t('user.first-name')}
                                value={userProfileInput.firstName}
                                onChange={e => setUserProfileInput(userProfileInput => {
                                    return {
                                        ...userProfileInput,
                                        firstName: e.target.value,
                                    };
                                })}
                            />

                            <FormControl
                                className="w-full"
                                type="text"
                                variant="modern"
                                label={t('user.last-name')}
                                value={userProfileInput.lastName}
                                onChange={e => setUserProfileInput(userProfileInput => {
                                    return {
                                        ...userProfileInput,
                                        lastName: e.target.value,
                                    };
                                })}
                            />

                        </div>

                        <div className="flex">
                            <Button className={'mt-2 ml-auto'} onClick={() => setButtonPressed(true)}>
                                {t('save')}
                            </Button>
                        </div>
                    </section>
                </LoadingComponent>
            </FormContainer>
        </div>
    );
}
